import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	displayText: {
		id: 'software.main.board-container.board.column.header.menu.item-limits.display-text',
		defaultMessage: 'Set column limit',
		description: '',
	},
});
